export default __webpack_public_path__ + "static/media/notebook-icon.a29ca900.svg";